export default __webpack_public_path__ + "static/ENG_ILGA_World_map_sexual_orientation_laws_thumb-585dd4885b3a0e795fdc34702a359c3a.png";